import { useQuery } from "@tanstack/react-query";
import api from "../api";
import { sampleReportKeys } from "../queryKeys";

const useLocalSampleDetails = (
  hash?: string,
  sourceId?: number | string,
  relationshipId?: number | string,
  droppedSourceId?: number | string,
  parentHash?: string,
  auxiliarySourceId?: number | string
) => {
  const { data, isPending, isFetched, error, isError } = useQuery({
    queryKey: sampleReportKeys.getLocalSampleDetails(
      hash,
      sourceId,
      relationshipId,
      droppedSourceId,
      parentHash,
      auxiliarySourceId
    ),
    queryFn: () =>
      api.getLocalSampleDetails(
        hash,
        sourceId,
        relationshipId,
        droppedSourceId,
        parentHash,
        auxiliarySourceId
      ),
    enabled: hash != null && sourceId != null,
    throwOnError: true,
    refetchOnMount: false,
    refetchOnWindowFocus: false
  });

  return {
    data: data?.data,
    isLoading: isPending,
    error,
    isError,
    isFetched
  };
};

export default useLocalSampleDetails;
